import { render, staticRenderFns } from "./AuditLogView.vue?vue&type=template&id=354bb7ca&scoped=true&"
import script from "./AuditLogView.vue?vue&type=script&lang=js&"
export * from "./AuditLogView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354bb7ca",
  null
  
)

export default component.exports